import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import ClientFacingStatus from 'domain/enums/ClientFacingStatus';
import RejectionReason from 'domain/types/RejectionReason';
import PrecheckFailed from 'features/group-details/PrecheckFailed';
import { GroupReferenceKey } from 'features/cart/CartSlice';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export function StatusAlert(props: {
  clientFacingStatusCd: ClientFacingStatus;
  rejections: RejectionReason[];
  groupRefKey: GroupReferenceKey;
  shouldCheckout: boolean;
  onCheckout: () => void;
  canRequestRenewal: boolean;
}) {
  let message = '';
  switch (props.clientFacingStatusCd) {
    case ClientFacingStatus.UNDER_REVIEW:
    case ClientFacingStatus.PRECHECK_PENDING:
    case ClientFacingStatus.RULES_ENGINE_PENDING: {
      message = 'This group reference is being reviewed.';
      break;
    }

    case ClientFacingStatus.PRECHECK_FAILED: {
      return (
        <PrecheckFailed
          groupRefKey={props.groupRefKey}
          rejections={props.rejections}
        />
      );
    }

    case ClientFacingStatus.APPROVED_PAYMENT_REQUIRED: {
      return (
        <Alert type={AlertType.success}>
          <h5>
            <span>Approved - Payment Required -</span>
            {props.shouldCheckout && (
              <Button variant='link' onClick={props.onCheckout}>
                Add to cart
              </Button>
            )}
            {!props.shouldCheckout && <span>&nbsp;Added to cart</span>}
          </h5>
        </Alert>
      );
    }

    case ClientFacingStatus.APPROVED: {
      return (
        <Alert type={AlertType.success}>
          <h5>Approved</h5>
        </Alert>
      );
    }

    case ClientFacingStatus.READY_FOR_RENEWAL: {
      return (
        <Alert type={AlertType.info}>
          <h5>
            <span>Ready for Renewal - </span>
            <Link to={`/renew-registration/${props.groupRefKey}`}>
              Request Renewal
            </Link>
          </h5>
        </Alert>
      );
    }

    case ClientFacingStatus.PAYMENT_PENDING: {
      message = 'Payment Pending';
      break;
    }
  }
  if (message) {
    return (
      <Alert type={AlertType.info}>
        <h5>{message}</h5>
      </Alert>
    );
  }
  return null;
}
